import CountriesDAO from "@/domains/Countries/CountriesDAO";
import Country from "@/domains/Countries/Country";
import Core from "@/core/Core";

class CountriesService {

    static async getList(
      params?: Parameters<typeof CountriesDAO.getList>[0]
    ): Promise<Country[]> {
        const response = await CountriesDAO.getList(params);

        return Core.utils.hydrateArray(response.data, Country.fromServer);
    }

    static search(pattern: string): Promise<Country[]> {
        return CountriesService.getList({ pattern });
    }
}

export default CountriesService;
